var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.37252 18.3335C3.33002 18.3335 1.66669 16.6416 1.66669 14.5631L1.66669 10.4288C1.66669 8.35445 3.32502 6.66683 5.36419 6.66683H14.6275C16.6709 6.66683 18.3334 8.35869 18.3334 10.4381V14.5707C18.3334 16.6459 16.675 18.3335 14.6359 18.3335H13.8525H5.37252Z",
    fill: "#003056"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54566 1.85098L7.1215 4.22247C6.8715 4.46758 6.8715 4.86201 7.12316 5.1063C7.37483 5.34978 7.78066 5.34897 8.03066 5.10468L9.35816 3.80531V5.05112V12.043C9.35816 12.388 9.64566 12.668 9.99983 12.668C10.3548 12.668 10.6415 12.388 10.6415 12.043V3.80531L11.969 5.10468C12.219 5.34897 12.6248 5.34978 12.8765 5.1063C13.0023 4.98375 13.0657 4.82387 13.0657 4.66317C13.0657 4.5041 13.0023 4.34421 12.8782 4.22247L10.4548 1.85098C10.334 1.7333 10.1707 1.66675 9.99983 1.66675C9.82983 1.66675 9.6665 1.7333 9.54566 1.85098Z",
    fill: "#003056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportExcel);
export default __webpack_public_path__ + "static/media/exportExcel.98cfb111c64fca2e6256e9161f174fa9.svg";
export { ForwardRef as ReactComponent };